import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuth } from "@/hooks/use-auth";

export function HomePage() {
  const { user } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center space-y-8 py-12">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
          Get the duck, not the decoy.
        </h1>
        <p className="max-w-[600px] text-lg text-muted-foreground">
          Pickwell works the whole catalog, spots the listings that only look right, and retrieves
          the few worth having — so you can buy with confidence.
        </p>
      </div>

      <div className="flex gap-4">
        {user ? (
          <Button asChild size="lg">
            <Link to="/dashboard">Go to Dashboard</Link>
          </Button>
        ) : (
          <Button asChild size="lg">
            <Link to="/login">Get Started</Link>
          </Button>
        )}
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-12">
        <Card>
          <CardHeader>
            <CardTitle>Works the whole pond</CardTitle>
            <CardDescription className="label text-xs">
              Not the first page of results
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Your requirements become a structured filter across the entire catalog. When we say
              four options survived, we mean out of all of them.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>The decoy check</CardTitle>
            <CardDescription className="label text-xs">
              Listing integrity, not star ratings
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Years of price, rating, and review-count history reveal listings that only look like
              the real thing. Every flag shows its evidence.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Reads the wind</CardTitle>
            <CardDescription className="label text-xs">
              The questions that change the answer
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Flying or driving? How many nights? Whether a travel crib is right depends on things a
              search box never asks.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>The retrieve</CardTitle>
            <CardDescription className="label text-xs">
              Rarely more than four, reasoning included
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Every recommendation comes with the tradeoffs and why the rest didn't make it — so you
              can disagree with us on the parts that are about your taste.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Came back empty</CardTitle>
            <CardDescription className="label text-xs">Honest beats agreeable</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Sometimes the honest answer is that none of them are good, or that the cheap one is
              fine. A store's own assistant can never tell you that.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Your dog, not a rental</CardTitle>
            <CardDescription className="label text-xs">
              The second time is better than the first
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              Your car, your kids' ages, your kitchen, what you returned and why — Pickwell
              remembers, so you never start from scratch.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
